import React from "react";
import ReactDOM from "react-dom/client";
import App from "src/App";

import "src/index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

window.onload = function () {
  root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
  );
};
